import { mapResponsiveStyles, type Types } from '@fiverr-private/theme';
import type { TextButtonProps, ResponsiveButtonSize } from './types';

const getColorByIntent = (
    disabled: TextButtonProps['disabled'],
    intent: TextButtonProps['intent']
): Types.BoxType['color'] => {
    if (disabled) {
        return 'grey_800';
    }

    return intent === 'primary' ? 'grey_1200' : 'red_900';
};

export const getStylingProps = (
    size: ResponsiveButtonSize,
    intent: TextButtonProps['intent'],
    variant: TextButtonProps['variant'],
    disabled: TextButtonProps['disabled']
): Types.BoxType => ({
    fontSize: mapResponsiveStyles(size, (value) => `b_${value}`),
    lineHeight: mapResponsiveStyles(size, (value) => `b_${value}`),
    decoration: variant === 'default' ? { hover: 'underline' } : { default: 'underline' },
    color: getColorByIntent(disabled, intent),
});
